import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class VendorNames {
	public static Cisco = "Cisco";
	public static Juniper = "Juniper";
	public static HP = "Hewlett Packard";
	public static _3Com = "3Com";
	public static Apple = "Apple";
	public static IBM = "IBM";
	public static Microsoft = "Microsoft";
	public static Dell = "Dell";
	public static Foundry = "Foundry";
	public static Nortel = "Nortel";
	public static Aruba = "Aruba";
	public static VMware = "VMware";

	public static IsApple(vendor: string): boolean {
		if (!vendor)
			return false;

		if (vendor.toLocaleLowerCase().indexOf(VendorNames.Apple.toLocaleLowerCase()) >= 0)
			return true;

		return false;
	}
}

//export interface ProductInfoJson {
//	vendor: string;
//	model: string;
//	description: string;
//}

export class ProductInfo extends InfoSet {
	//public static FromJson(json: ProductInfoJson, device: Device):ProductInfo {
	//	var result = new ProductInfo(device);

	//	result.Vendor = json.vendor;
	//	result.Model = json.model;
	//	result.Description = json.description;

	//	return result;
	//}

	public Vendor: string;
	public Model: string;
	public Description: string;

	constructor(device: Device) {
		super(device);
		this.Vendor = "";
		this.Model = "";
		this.Description = "";
	}

	public get HasVendor(): boolean {
		return !!this.Vendor;
	}

	public get HasModel(): boolean {
		return !!this.Model;
	}

	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public Write(obj: any, context: any): void {
		obj.product_info = {};
		obj = obj.product_info;

		if (this.HasVendor)
			obj.vendor = this.Vendor;

		if (this.HasModel)
			obj.model = this.Model;

		if (this.HasDescription)
			obj.description = this.Description;
	}

	public Read(obj: any, context: any): void {
		if (!obj.product_info)
			throw new Error();
		obj = obj.product_info;

		if (obj.vendor !== undefined)
			this.Vendor = obj.vendor;

		if (obj.model !== undefined)
			this.Model = obj.model;

		if (obj.description !== undefined)
			this.Description = obj.description;
	}

}
